// extracted by mini-css-extract-plugin
export default {"form-information-container":"FormInformation_form-information-container__Iyc0A","error":"FormInformation_error__RhAtA"};